module.exports = __webpack_public_path__ + "static/media/facebook.c36c6b91.svg";